import {
  CreateOrganization as CreateOrganization2,
  OrgMemberReference,
  OrganizationAlertsScene,
  OrganizationAuditLogScene,
  OrganizationBillingScene,
  OrganizationGeneralScene,
  OrganizationInvitesScene,
  OrganizationMembersScene,
  OrganizationSSOScene,
  OrganizationWorkspaceScene,
  OrganizationWorkspacesScene,
  WorkspaceEmptyState,
  createOrganization as createOrganization2
} from "./chunk-YOANETQR.js";
import {
  createProject
} from "./chunk-QYWN3V55.js";
import {
  createInstance,
  createProject as createProject2,
  updateInstance,
  updateProject
} from "./chunk-V26GONG3.js";
import {
  CreateOrganization,
  createOrganization
} from "./chunk-MJWTRZ63.js";
import "./chunk-PVCBGE2K.js";
import {
  OnboardingList,
  useOnboardingList
} from "./chunk-5KBKVBSR.js";
import {
  getRoute,
  routes,
  setRoute
} from "./chunk-7PKRU6HZ.js";
import {
  openCheckoutModal
} from "./chunk-IKCASY5M.js";
import {
  __export,
  __reExport
} from "./chunk-F5QR3K72.js";

// src/index.ts
var src_exports = {};
__export(src_exports, {
  AccountEmailsScene: () => AccountEmailsScene,
  AccountOrganizationsScene: () => AccountOrganizationsScene,
  AccountProfileScene: () => AccountProfileScene,
  AccountSecurityScene: () => AccountSecurityScene,
  ApiErrors: () => ApiErrors,
  ApiKeyListTable: () => ApiKeyListTable,
  AppLayout: () => AppLayout,
  ApplicationList: () => ApplicationList,
  ApplicationsPage: () => ApplicationsPage,
  BoxLayout: () => BoxLayout,
  CreateOrganization: () => CreateOrganization2,
  EventLogs: () => EventLogs,
  HomePage: () => HomePage,
  InstanceHeaderLayout: () => InstanceHeaderLayout,
  LargePaneLayout: () => LargePaneLayout,
  Nav: () => Nav,
  ObjectComments: () => ObjectComments,
  ObjectGroupPage: () => ObjectGroupPage,
  ObjectHeader: () => ObjectHeader,
  OnboardingList: () => OnboardingList2,
  OrgMemberReference: () => OrgMemberReference,
  OrganizationAlertsScene: () => OrganizationAlertsScene,
  OrganizationAuditLogScene: () => OrganizationAuditLogScene,
  OrganizationBillingScene: () => OrganizationBillingScene,
  OrganizationGeneralScene: () => OrganizationGeneralScene,
  OrganizationInvitesScene: () => OrganizationInvitesScene,
  OrganizationMembersScene: () => OrganizationMembersScene,
  OrganizationSSOScene: () => OrganizationSSOScene,
  OrganizationWorkspaceScene: () => OrganizationWorkspaceScene,
  OrganizationWorkspacesScene: () => OrganizationWorkspacesScene,
  Plan: () => Plan,
  PriceHeader: () => PriceHeader,
  RenderPricingTable: () => RenderPricingTable,
  RequestLogs: () => RequestLogs,
  RequestTimeline: () => RequestTimeline,
  Subscription: () => Subscription,
  SwitcherHorizontal: () => SwitcherHorizontal,
  SwitcherVertical: () => SwitcherVertical,
  TicketChat: () => TicketChat,
  TicketList: () => TicketList,
  User: () => User,
  WorkspaceEmptyState: () => WorkspaceEmptyState,
  WorkspacePane: () => WorkspacePane,
  createApiKeyModal: () => createApiKeyModal,
  createApplicationModal: () => createApplicationModal2,
  createInstance: () => createInstance,
  createOrganization: () => createOrganization2,
  createProject: () => createProject2,
  getAresRoute: () => getRoute,
  openCheckoutModal: () => openCheckoutModal,
  rollApiKeyModal: () => rollApiKeyModal,
  setAresRoute: () => setRoute,
  updateApiKeyModal: () => updateApiKeyModal,
  updateApplicationModal: () => updateApplicationModal2,
  updateInstance: () => updateInstance,
  updateProject: () => updateProject
});

// src/account/index.ts
import { dynamicComponent } from "@lb-lib/dynamic-component";
var AccountEmailsScene = dynamicComponent(async () => (await import("./emails-EV7L5CHE.js")).AccountEmailsScene);
var AccountOrganizationsScene = dynamicComponent(async () => (await import("./organizations-KEHBM5E5.js")).AccountOrganizationsScene);
var AccountProfileScene = dynamicComponent(async () => (await import("./profile-C76NNJJ5.js")).AccountProfileScene);
var AccountSecurityScene = dynamicComponent(async () => (await import("./security-FVIBTX3O.js")).AccountSecurityScene);

// src/billing/index.ts
import { dynamicComponent as dynamicComponent2 } from "@lb-lib/dynamic-component";
var Plan = dynamicComponent2(async () => (await import("./plan-EMPI5VMW.js")).Plan);
var PriceHeader = dynamicComponent2(async () => (await import("./priceHeader-SSQMV64E.js")).PriceHeader);
var RenderPricingTable = dynamicComponent2(async () => (await import("./pricingTable-F76F4D7J.js")).RenderPricingTable);
var Subscription = dynamicComponent2(async () => (await import("./subscription-NQ4CC7VA.js")).Subscription);

// src/dashboard/object/index.ts
import { dynamicComponent as dynamicComponent3 } from "@lb-lib/dynamic-component";

// src/dashboard/object/header.tsx
import { EditableText } from "@loopbound-ares/components";
import { useDashboardObject, useUpdateDashboardObject } from "@loopbound-ares/state";
import styled from "styled-components";
import { jsx } from "react/jsx-runtime";
var Wrapper = styled.div.withConfig({
  componentId: "sc-l0qram-0"
})`display:flex;flex-direction:column;gap:2px;`;
var ObjectHeader = ({
  object: objectInfo,
  defaults
}) => {
  let object = useDashboardObject(objectInfo);
  let updateObject = useUpdateDashboardObject();
  return /* @__PURE__ */ jsx(Wrapper, { children: /* @__PURE__ */ jsx(EditableText, { layers: [{
    fontSize: 22,
    fontWeight: 600,
    placeholder: "Untitled",
    state: () => ({
      value: object.data?.name ?? defaults?.name ?? "",
      isLoading: updateObject.isLoading || object.isLoading,
      onChange: async (value) => updateObject.mutate({
        instanceId: object.data?.instanceId,
        object: objectInfo,
        name: value
      })
    })
  }, {
    fontSize: 14,
    fontWeight: 400,
    placeholder: "Enter a description",
    state: () => ({
      value: object.data?.description ?? defaults?.description ?? "",
      isLoading: updateObject.isLoading,
      onChange: async (value) => updateObject.mutate({
        instanceId: object.data?.instanceId,
        object: objectInfo,
        description: value
      })
    })
  }] }) });
};

// src/dashboard/object/index.ts
var ObjectComments = dynamicComponent3(async () => (await import("./comment-ZHER5AMF.js")).ObjectComments);

// src/dashboard/onboarding/index.ts
import { dynamicComponent as dynamicComponent4 } from "@lb-lib/dynamic-component";
var OnboardingList2 = dynamicComponent4(async () => (await import("./list-QDQESMXG.js")).OnboardingList);

// src/dashboard/page/objectGroupPage/index.tsx
import { Button, CenteredSpinner, confirm, Dialog as Dialog2, Error, Flex, LinkButton, Menu, showModal as showModal2, SortableCheckList, Spacer, Text, theme, Title } from "@lb-lib/ui";
import { PageHeader } from "@loopbound-ares/components";
import { useArchiveDashboardPageObjectGroup, useCurrentInstance as useCurrentInstance2, useDashboardPage, useOrderDashboardPageObjectGroup } from "@loopbound-ares/state";
import { Fragment, useMemo, useState } from "react";
import { MoreVertical } from "react-feather";
import styled2 from "styled-components";

// src/dashboard/page/objectGroupPage/form.tsx
import { Dialog, showModal } from "@lb-lib/ui";
import { form } from "@lb-lib/ui-data";
import { useCreateDashboardPageObjectGroup, useCurrentInstance, useUpdateDashboardPageObjectGroup } from "@loopbound-ares/state";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var UpdateObjectGroupForm = form({
  name: "update_object_group",
  updateInitialValues: true,
  initialData: {
    name: "",
    description: ""
  },
  state: (input) => {
    let mutation = useUpdateDashboardPageObjectGroup();
    let instance = useCurrentInstance();
    return {
      isLoading: mutation.isLoading,
      isSuccess: mutation.isSuccess,
      error: mutation.error,
      result: mutation.data,
      initialData: {
        name: input.objectGroup.name,
        description: input.objectGroup.description || ""
      },
      mutate: async (v) => {
        if (!instance.data)
          return;
        await mutation.mutate({
          instanceId: instance.data.instance.id,
          objectGroupId: input.objectGroup.id,
          pageKey: input.pageKey,
          ...v
        });
      }
    };
  },
  submitButton: {
    children: "Save",
    variant: "solid"
  },
  fields: [{
    type: "textfield",
    key: "name",
    label: "Name",
    kind: "text",
    validation: (yup) => yup.string().required("Name is required")
  }, {
    type: "textfield",
    key: "description",
    label: "Description",
    kind: "text",
    minRows: 3,
    as: "textarea"
  }]
});
var CreateObjectGroupForm = form({
  name: "create_object_group",
  initialData: {
    name: "",
    description: ""
  },
  state: (input) => {
    let mutation = useCreateDashboardPageObjectGroup();
    let instance = useCurrentInstance();
    return {
      isLoading: mutation.isLoading,
      isSuccess: mutation.isSuccess,
      error: mutation.error,
      result: mutation.data,
      mutate: async (v) => {
        if (!instance.data)
          return;
        await mutation.mutate({
          instanceId: instance.data?.instance.id,
          pageKey: input.pageKey,
          ...v
        });
      }
    };
  },
  submitButton: {
    children: "Create",
    variant: "solid"
  },
  fields: [{
    type: "textfield",
    key: "name",
    label: "Name",
    kind: "text",
    validation: (yup) => yup.string().required("Name is required")
  }, {
    type: "textfield",
    key: "description",
    label: "Description",
    kind: "text",
    minRows: 3,
    as: "textarea"
  }]
});
var createObjectGroupModal = ({
  item,
  pageKey
}) => showModal(({
  dialogProps
}) => /* @__PURE__ */ jsxs(Dialog.Wrapper, { ...dialogProps, children: [
  /* @__PURE__ */ jsx2(Dialog.Title, { children: "Create Group" }),
  /* @__PURE__ */ jsxs(Dialog.Description, { children: [
    "Use groups to organize your ",
    item.pluralLowerCase,
    "."
  ] }),
  /* @__PURE__ */ jsx2(CreateObjectGroupForm, { pageKey })
] }));
var updateObjectGroupModal = ({
  objectGroup,
  pageKey
}) => showModal(({
  dialogProps
}) => /* @__PURE__ */ jsxs(Dialog.Wrapper, { ...dialogProps, children: [
  /* @__PURE__ */ jsx2(Dialog.Title, { children: "Update Group" }),
  /* @__PURE__ */ jsx2(UpdateObjectGroupForm, { objectGroup, pageKey })
] }));

// src/dashboard/page/objectGroupPage/index.tsx
import { Fragment as Fragment2, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var Wrapper2 = styled2.div.withConfig({
  componentId: "sc-1vzxbzo-0"
})`display:flex;flex-direction:column;gap:20px;`;
var GroupWrapper = styled2.section.withConfig({
  componentId: "sc-1vzxbzo-1"
})`display:flex;flex-direction:column;gap:10px;`;
var GroupHeader = styled2.header.withConfig({
  componentId: "sc-1vzxbzo-2"
})`display:flex;justify-content:space-between;align-items:center;gap:10px;border-bottom:1px solid ${theme.colors.gray300};padding-bottom:10px;`;
var ItemGrid = styled2.div.withConfig({
  componentId: "sc-1vzxbzo-3"
})`display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:10px;`;
var ObjectGroupPage = ({
  item,
  items,
  header,
  pageKey,
  onCreateItem
}) => {
  let instance = useCurrentInstance2();
  let groups = useDashboardPage(pageKey);
  let archive = useArchiveDashboardPageObjectGroup();
  let itemsByGroup = useMemo(() => {
    if (!groups.data?.objectGroups || !items.data)
      return [];
    let allItems = [...items.data];
    let grouped = groups.data?.objectGroups.map((group) => {
      let items2 = allItems.filter((i) => i.objectGroupId == group.id);
      allItems = allItems.filter((i) => i.objectGroupId != group.id);
      return {
        group,
        items: items2
      };
    }) ?? [];
    if (allItems.length) {
      for (let g of grouped) {
        if (g.group.isDefault) {
          g.items = [...g.items, ...allItems];
        }
      }
    }
    return grouped.map((g) => ({
      ...g,
      items: g.items.sort((a, b) => a.id.localeCompare(b.id))
    })).filter((g) => g.group.status == "active");
  }, [groups.data?.objectGroups, items]);
  let onDeleteGroup = (group) => {
    confirm({
      title: "Archive Section",
      description: `Are you sure you want to archive the section "${group.name}"? This will archive all ${item.pluralLowerCase} in this section.`,
      confirmText: "Archive",
      onConfirm() {
        archive.mutate({
          pageKey,
          objectGroupId: group.id,
          instanceId: instance.data?.instance.id
        });
      }
    });
  };
  return /* @__PURE__ */ jsxs2(Fragment2, { children: [
    /* @__PURE__ */ jsx3(PageHeader, { ...header, size: "2", actions: /* @__PURE__ */ jsx3("div", { style: {
      display: "flex",
      gap: 10
    }, children: /* @__PURE__ */ jsx3(Menu, { onItemClick: (id) => {
      if (id == "group")
        createObjectGroupModal({
          item,
          pageKey
        });
      if (id == "recorder")
        showModal2(({
          dialogProps,
          close
        }) => {
          let order = useOrderDashboardPageObjectGroup();
          let [items2, setItems] = useState(() => groups.data.objectGroups.map((g) => ({
            id: g.id,
            label: g.name,
            isChecked: g.status == "active"
          })) ?? []);
          return /* @__PURE__ */ jsxs2(Dialog2.Wrapper, { ...dialogProps, children: [
            /* @__PURE__ */ jsx3(Dialog2.Title, { children: "Manage Sections" }),
            /* @__PURE__ */ jsx3(Spacer, { height: 6 }),
            /* @__PURE__ */ jsx3(SortableCheckList, { items: items2, onChange: (v) => setItems(v) }),
            /* @__PURE__ */ jsx3(Dialog2.Actions, { children: /* @__PURE__ */ jsx3(Button, { size: "2", disabled: items2.every((i) => !i.isChecked), onClick: async () => {
              await order.mutate({
                pageKey,
                instanceId: instance.data?.instance.id,
                order: items2.map((i) => ({
                  id: i.id,
                  archived: !i.isChecked
                }))
              });
              setTimeout(close, 500);
            }, variant: "solid", loading: order.isLoading, success: order.isSuccess, children: "Save" }) })
          ] });
        });
      if (id == "item") {
        let defaultGroup = groups.data?.objectGroups.find((g) => g.isDefault);
        if (defaultGroup)
          onCreateItem(defaultGroup);
      }
    }, items: [{
      id: "group",
      label: "Create Section"
    }, {
      id: "recorder",
      label: "Manage Sections"
    }, {
      id: "item",
      label: `Create ${item.singularUpperCase}`
    }], children: /* @__PURE__ */ jsx3(Button, { size: "2", variant: "outline", iconLeft: /* @__PURE__ */ jsx3(MoreVertical, {}), title: "More options" }) }) }) }),
    /* @__PURE__ */ jsx3(Wrapper2, { children: items.error ? /* @__PURE__ */ jsx3(Error, { children: items.error.data.message }) : groups.isLoading || items.isLoading ? /* @__PURE__ */ jsx3(CenteredSpinner, {}) : itemsByGroup.map(({
      group,
      items: items2
    }) => /* @__PURE__ */ jsxs2(GroupWrapper, { children: [
      /* @__PURE__ */ jsxs2(GroupHeader, { children: [
        /* @__PURE__ */ jsxs2(Flex, { direction: "column", gap: 5, children: [
          /* @__PURE__ */ jsx3(Title, { as: "h2", size: "4", weight: "bold", children: group.name }),
          group.description && /* @__PURE__ */ jsx3(Text, { size: "2", color: "gray600", weight: "medium", children: group.description.split("\n").map((line, i) => /* @__PURE__ */ jsxs2(Fragment, { children: [
            line,
            /* @__PURE__ */ jsx3("br", {})
          ] }, i)) })
        ] }),
        /* @__PURE__ */ jsxs2(Flex, { wrap: "wrap", gap: "10px", children: [
          /* @__PURE__ */ jsxs2(Button, { size: "2", onClick: () => onCreateItem(group), variant: "solid", children: [
            "Create ",
            item.singularUpperCase
          ] }),
          /* @__PURE__ */ jsx3(Menu, { onItemClick: (id) => {
            if (id == "edit")
              updateObjectGroupModal({
                objectGroup: group,
                pageKey
              });
            if (id == "archive")
              onDeleteGroup(group);
            if (id == "item")
              onCreateItem(group);
          }, items: [{
            id: "edit",
            label: "Edit Section"
          }, {
            id: "archive",
            label: "Archive Section"
          }, {
            id: "item",
            label: `Create ${item.singularUpperCase}`
          }], children: /* @__PURE__ */ jsx3(Button, { size: "2", variant: "outline", iconLeft: /* @__PURE__ */ jsx3(MoreVertical, {}), title: "More options" }) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs2(ItemGrid, { style: {
        display: items2.length > 0 ? "grid" : "block"
      }, children: [
        items2.map((item2) => /* @__PURE__ */ jsx3(Fragment, { children: item2.children }, item2.id)),
        items2.length == 0 && /* @__PURE__ */ jsxs2(Text, { size: "2", color: "gray600", children: [
          "This section has no ",
          item.pluralLowerCase,
          " yet.",
          " ",
          /* @__PURE__ */ jsx3(LinkButton, { onClick: () => onCreateItem(group), children: "Let's create one!" })
        ] })
      ] })
    ] }, group.id)) })
  ] });
};

// src/developer/apiKey/index.ts
import { dynamicComponent as dynamicComponent5, dynamicFunction } from "@lb-lib/dynamic-component";
var ApiKeyListTable = dynamicComponent5(async () => (await import("./apiKeyList-RETV53JN.js")).ApiKeyListTable);
var createApiKeyModal = dynamicFunction(async () => (await import("./createApiKeyForm-NJ2ZJZKX.js")).createApiKeyModal);
var updateApiKeyModal = dynamicFunction(async () => (await import("./updateApiKeyForm-U2JVOPV5.js")).updateApiKeyModal);
var rollApiKeyModal = dynamicFunction(async () => (await import("./rollApiKeyModal-FZMYY4UV.js")).rollApiKeyModal);

// src/developer/application/index.ts
import { dynamicFunction as dynamicFunction4 } from "@lb-lib/dynamic-component";

// src/developer/application/applicationList.tsx
import { dynamicFunction as dynamicFunction2 } from "@lb-lib/dynamic-component";
import { Button as Button2, Entity, Menu as Menu2, Text as Text2, Title as Title2 } from "@lb-lib/ui";
import { renderWithLoader } from "@loopbound-ares/components";
import { useApplications, useCreateApplication, useCurrentInstance as useCurrentInstance3 } from "@loopbound-ares/state";
import { RiAddLine } from "@remixicon/react";
import { useEffect, useRef, useState as useState2 } from "react";
import { MoreVertical as MoreVertical2 } from "react-feather";
import styled3 from "styled-components";
import { Fragment as Fragment3, jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var updateApplicationModal = dynamicFunction2(async () => (await import("./updateApplicationForm-KWCBP7UU.js")).updateApplicationModal);
var Wrapper3 = styled3("div").withConfig({
  componentId: "sc-17i01wp-0"
})`display:flex;flex-direction:column;gap:20px;`;
var ApplicationList = (opts) => {
  let instance = useCurrentInstance3();
  let applications = useApplications(instance.data ? {
    organizationId: instance.data.organization.id,
    instanceIds: [instance.data.instance.id]
  } : null);
  let initializingRef = useRef(false);
  let createApplication = useCreateApplication();
  let [creatingInitialApplication, setCreatingInitialApplication] = useState2(false);
  useEffect(() => {
    if (instance.data && !applications.error && !applications.isLoading && !applications.data.length && !initializingRef.current) {
      setCreatingInitialApplication(true);
      initializingRef.current = true;
      createApplication.mutate({
        instanceId: instance.data.instance.id,
        name: "Default Application",
        description: `Default application for ${instance.data.instance.name}`
      }).finally(() => {
        setCreatingInitialApplication(false);
      });
    }
  }, [instance.data, applications.data, applications.isLoading, applications.error]);
  return /* @__PURE__ */ jsx4(Wrapper3, { children: renderWithLoader({
    instance,
    applications,
    creatingInitialApplication
  })(() => /* @__PURE__ */ jsx4(Fragment3, { children: applications.data.map((application) => /* @__PURE__ */ jsxs3(Entity.Wrapper, { children: [
    /* @__PURE__ */ jsx4(Entity.Header, { children: /* @__PURE__ */ jsxs3("div", { style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 10,
      width: "100%"
    }, children: [
      /* @__PURE__ */ jsxs3("div", { children: [
        /* @__PURE__ */ jsx4(Title2, { as: "h2", size: "3", weight: "bold", children: application.name }),
        application.description && /* @__PURE__ */ jsx4(Text2, { size: "2", color: "gray600", weight: "strong", children: application.description })
      ] }),
      /* @__PURE__ */ jsxs3("div", { style: {
        display: "flex",
        gap: 10
      }, children: [
        /* @__PURE__ */ jsx4(Button2, { size: "1", iconLeft: /* @__PURE__ */ jsx4(RiAddLine, {}), onClick: () => createApiKeyModal({
          application,
          organizationId: instance.data.organization.id
        }), children: "Create Api Key" }),
        /* @__PURE__ */ jsx4(Menu2, { items: [{
          id: "update",
          label: "Update"
        }, {
          id: "create-api-key",
          label: "Create Api Key"
        }], onItemClick: (item) => {
          if (item == "update")
            updateApplicationModal({
              application,
              organizationId: instance.data.organization.id
            });
          if (item == "create-api-key")
            createApiKeyModal({
              application,
              organizationId: instance.data.organization.id
            });
        }, children: /* @__PURE__ */ jsx4(Button2, { size: "1", variant: "outline", iconLeft: /* @__PURE__ */ jsx4(MoreVertical2, {}), title: "Open application options" }) })
      ] })
    ] }) }),
    /* @__PURE__ */ jsx4(Entity.ContentRaw, { style: {
      padding: "15px 0px 0px 0px"
    }, children: /* @__PURE__ */ jsx4(ApiKeyListTable, { sidePadding: 15, types: opts.keyTypes, application }) })
  ] }, application.id)) })) });
};

// src/developer/application/applicationsPage.tsx
import { dynamicFunction as dynamicFunction3 } from "@lb-lib/dynamic-component";
import { Button as Button3 } from "@lb-lib/ui";
import { PageHeader as PageHeader2 } from "@loopbound-ares/components";
import { useCurrentInstance as useCurrentInstance4 } from "@loopbound-ares/state";
import { Fragment as Fragment4, jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var createApplicationModal = dynamicFunction3(async () => (await import("./createApplicationForm-A2Z4ASOS.js")).createApplicationModal);
var ApplicationsPage = (opts) => {
  let instance = useCurrentInstance4();
  return /* @__PURE__ */ jsxs4(Fragment4, { children: [
    /* @__PURE__ */ jsx5(PageHeader2, { title: "API Applications", description: "Applications are used to manage your API keys and access to APIs.", actions: /* @__PURE__ */ jsx5(Button3, { size: "2", onClick: () => {
      if (!instance.data)
        return;
      createApplicationModal({
        instanceId: instance.data.instance.id
      });
    }, children: "Create Application" }) }),
    /* @__PURE__ */ jsx5(ApplicationList, { keyTypes: opts.keyTypes })
  ] });
};

// src/developer/application/index.ts
var createApplicationModal2 = dynamicFunction4(async () => (await import("./createApplicationForm-A2Z4ASOS.js")).createApplicationModal);
var updateApplicationModal2 = dynamicFunction4(async () => (await import("./updateApplicationForm-KWCBP7UU.js")).updateApplicationModal);

// src/developer/events/index.ts
import { dynamicComponent as dynamicComponent6 } from "@lb-lib/dynamic-component";
var EventLogs = dynamicComponent6(async () => (await import("./logs-F2KWKI26.js")).EventLogs);

// src/developer/requests/index.ts
import { dynamicComponent as dynamicComponent7 } from "@lb-lib/dynamic-component";
var ApiErrors = dynamicComponent7(async () => (await import("./errors-65WTH6VU.js")).ApiErrors);
var RequestLogs = dynamicComponent7(async () => (await import("./logs-YBJUELQE.js")).RequestLogs);
var RequestTimeline = dynamicComponent7(async () => (await import("./timeline-QUR2HHZC.js")).RequestTimeline);

// src/layouts/appLayout.tsx
import { LinkTabs, Text as Text3, Title as Title3, theme as theme2 } from "@lb-lib/ui";
import { Breadcrumbs, ContentLayout } from "@loopbound-ares/components";
import { createContext, useContext, useMemo as useMemo2 } from "react";
import { useLocation } from "react-router-dom";
import styled4 from "styled-components";
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var Wrapper4 = styled4("div").withConfig({
  componentId: "sc-1qzjftg-0"
})`display:flex;flex-direction:column;position:relative;min-height:100%;flex-grow:1;`;
var HeaderWrapper = styled4("header").withConfig({
  componentId: "sc-1qzjftg-1"
})`border-bottom:1px solid ${theme2.colors.gray300};position:sticky;top:5px;background:${theme2.colors.background};z-index:auto;padding:10px 0px 10px 0px;display:flex;flex-direction:column;align-items:center;width:100%;`;
var HeaderInner = styled4("div").withConfig({
  componentId: "sc-1qzjftg-2"
})`display:flex;gap:10px;flex-wrap:wrap;justify-content:space-between;align-items:center;width:100%;`;
var HeaderContent = styled4("div").withConfig({
  componentId: "sc-1qzjftg-3"
})`display:flex;flex-direction:column;gap:3px;`;
var Actions = styled4("div").withConfig({
  componentId: "sc-1qzjftg-4"
})`display:flex;gap:10px;`;
var sizes = {
  slim: "600px",
  medium: "800px",
  large: "1000px",
  full: "100%"
};
var AppLayoutContext = createContext(void 0);
var Component = ({
  children,
  ...state
}) => {
  let {
    title,
    header,
    description,
    navigation,
    breadcrumbs,
    actions,
    width = "large"
  } = state;
  let navItems = navigation?.items.map((item) => ({
    to: `${navigation.basePath}${item.to}`,
    label: item.label
  }));
  let path = useLocation().pathname;
  let current = useMemo2(() => {
    let matches = navItems?.filter((item) => item.to == path || path.startsWith(`${item.to}/`)).sort((a, b) => b.to.length - a.to.length);
    let bestMatch = matches?.[0];
    return bestMatch;
  }, [navItems, path]);
  return /* @__PURE__ */ jsx6(AppLayoutContext.Provider, { value: state, children: /* @__PURE__ */ jsxs5(Wrapper4, { children: [
    /* @__PURE__ */ jsxs5(HeaderWrapper, { style: navItems ? {
      borderBottom: "none",
      paddingBottom: 0
    } : {}, children: [
      (breadcrumbs || title || description) && /* @__PURE__ */ jsx6("div", { style: {
        padding: "10px 25px",
        width: "100%",
        display: "flex",
        justifyContent: "center"
      }, children: /* @__PURE__ */ jsxs5(HeaderInner, { style: {
        paddingBottom: navItems ? 15 : 0,
        width: sizes[width],
        maxWidth: "100%"
      }, children: [
        /* @__PURE__ */ jsxs5(HeaderContent, { children: [
          breadcrumbs && /* @__PURE__ */ jsx6(Breadcrumbs, { breadcrumbs }),
          header && /* @__PURE__ */ jsx6("div", { children: header }),
          title && /* @__PURE__ */ jsx6(Title3, { as: "h1", size: "3", weight: "strong", children: title }),
          description && /* @__PURE__ */ jsx6(Text3, { size: "2", weight: "medium", color: "gray600", children: description })
        ] }),
        actions && /* @__PURE__ */ jsx6(Actions, { children: actions })
      ] }) }),
      navItems && /* @__PURE__ */ jsx6(LinkTabs, { current: current?.to ?? "..", links: navItems, maxWidth: sizes[width], padding: {
        top: 0,
        right: 25,
        bottom: 10,
        left: 25
      }, margin: {
        top: 0,
        bottom: 0
      }, height: 30 })
    ] }),
    /* @__PURE__ */ jsx6("div", { style: {
      flexGrow: 1,
      display: "flex",
      flexDirection: "column"
    }, children })
  ] }) });
};
var Content = ({
  children,
  width
}) => {
  let state = useContext(AppLayoutContext);
  let widthProp = width ?? state?.width ?? "large";
  if (widthProp == "full")
    return children;
  return /* @__PURE__ */ jsx6(ContentLayout, { variant: widthProp, children });
};
var AppLayout = Object.assign(Component, {
  Content
});

// src/layouts/boxLayout.tsx
import { LinkButton as LinkButton2, theme as theme3 } from "@lb-lib/ui";
import { redirectToUserSelector, useShell, useUser } from "@loopbound-ares/state";
import * as Dialog3 from "@radix-ui/react-dialog";
import { Link } from "react-router-dom";
import styled5 from "styled-components";
import { Fragment as Fragment5, jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var Wrapper5 = styled5(Dialog3.Content).withConfig({
  componentId: "sc-avx40j-0"
})`position:fixed;top:0;left:0;right:0;bottom:0;overflow:auto;background:${theme3.colors.background};display:flex;justify-content:space-between;align-items:center;flex-direction:column;`;
var Box = styled5("main").withConfig({
  componentId: "sc-avx40j-1"
})`width:1100px;max-width:calc(100% - 40px);padding:80px 50px;margin:0 auto;display:flex;justify-content:center;align-items:center;background:rgba(255,255,255,0.9);backdrop-filter:blur(20px);border-radius:15px;border:1px solid ${theme3.colors.gray300};min-height:70vh;@media (max-width:800px){border:none;padding:0px;align-items:flex-start;min-height:unset;}`;
var Inner = styled5("div").withConfig({
  componentId: "sc-avx40j-2"
})`width:min(100%,400px);`;
var Footer = styled5("footer").withConfig({
  componentId: "sc-avx40j-3"
})`margin:20px;p{font-size:12px;color:${theme3.colors.gray700};a{color:inherit;text-decoration:underline;}strong{font-weight:600;}}`;
var Header = styled5("header").withConfig({
  componentId: "sc-avx40j-4"
})`margin:20px;svg{height:40px;width:auto;}`;
var BoxLayout = ({
  children,
  withAccountManagement,
  selectAccountWithFullPath
}) => {
  let user = useUser();
  let ctx = useShell();
  return /* @__PURE__ */ jsx7(Dialog3.Root, { open: true, children: /* @__PURE__ */ jsx7(Dialog3.Portal, { children: /* @__PURE__ */ jsxs6(Wrapper5, { children: [
    /* @__PURE__ */ jsx7(Header, { children: ctx.logo }),
    /* @__PURE__ */ jsx7(Box, { children: /* @__PURE__ */ jsx7(Inner, { children }) }),
    /* @__PURE__ */ jsx7(Footer, { children: /* @__PURE__ */ jsxs6("p", { children: [
      "You are logged in as ",
      /* @__PURE__ */ jsx7("strong", { children: user?.data?.email }),
      ".",
      " ",
      withAccountManagement !== false && /* @__PURE__ */ jsxs6(Fragment5, { children: [
        /* @__PURE__ */ jsx7(Link, { to: "/account", children: "Manage Account" }),
        " or",
        " "
      ] }),
      /* @__PURE__ */ jsx7(LinkButton2, { onClick: () => redirectToUserSelector(void 0, {
        withFullPath: selectAccountWithFullPath
      }), children: "Switch User" })
    ] }) })
  ] }) }) });
};

// src/layouts/instanceHeaderLayout.tsx
import { Menu as Menu3, theme as theme4 } from "@lb-lib/ui";
import { useMutation } from "@lb-lib/ui-data";
import { bootWorkspace, useCurrentBootWorkspace, useCurrentInstance as useCurrentInstance5 } from "@loopbound-ares/state";
import { RiArrowDownSLine } from "@remixicon/react";
import { useRef as useRef2, useState as useState3 } from "react";
import { useNavigate } from "react-router-dom";
import styled6 from "styled-components";
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var Wrapper6 = styled6("div").withConfig({
  componentId: "sc-1ef5xx1-0"
})`min-height:100%;display:flex;flex-direction:column;`;
var HEIGHT = 5;
var Header2 = styled6("header").withConfig({
  componentId: "sc-1ef5xx1-1"
})`display:flex;height:${HEIGHT}px;align-items:center;padding:0px 10px;position:sticky;top:0;z-index:50;flex-shrink:0;transition:background 0.2s;`;
var HeaderMarker = styled6("div").withConfig({
  componentId: "sc-1ef5xx1-2"
})`position:absolute;top:0;left:50%;transform:translateX(-50%);transition:all 0.2s;padding-bottom:15px;z-index:51;& > div{height:10px;min-width:100px;max-width:100px;border-radius:5px;transition:all 0.2s;display:flex;align-items:center;justify-content:center;& > div{opacity:0;pointer-events:none;transition:all 0.2s;padding:0px;}}&:hover,&:focus,&:active,&:focus-within,&[data-state='open']{padding-top:10px;& > div{border-radius:100px;width:auto;height:30px;min-width:30px;max-width:500px;& > div{opacity:1;pointer-events:all;}}}`;
var TitleButton = styled6("button").withConfig({
  componentId: "sc-1ef5xx1-3"
})`background:none;border:none;color:${theme4.colors.gray900};cursor:pointer;font-size:14px;font-weight:600;padding:0px 7px 0px 9px;display:flex;align-items:center;gap:4px;transition:background 0.2s;border-radius:60px;outline:none;height:30px;&:focus,&:active{background:rgba(0,0,0,0.05);}`;
var InstanceHeaderLayout = ({
  children
}) => {
  let instance = useCurrentInstance5();
  let navigate = useNavigate();
  let [selectorOpen, setSelectorOpen] = useState3(false);
  let creatingProductionInstance = useRef2(false);
  let bwsp = useCurrentBootWorkspace();
  let createInstanceMutator = useMutation(bwsp.mutators.createInstance);
  let color = !instance.data ? "white" : instance.data.instance.environment.type == "production" ? "blue" : "orange";
  return /* @__PURE__ */ jsxs7(Wrapper6, { children: [
    /* @__PURE__ */ jsx8(Header2, { style: {
      background: theme4.colors[`${color}700`]
    }, children: /* @__PURE__ */ jsx8(HeaderMarker, { "data-state": selectorOpen ? "open" : "closed", children: /* @__PURE__ */ jsx8("div", { style: {
      background: theme4.colors[`${color}700`]
    }, children: /* @__PURE__ */ jsx8("div", { children: /* @__PURE__ */ jsx8(Menu3, { setIsOpen: setSelectorOpen, title: "Select Instance", items: [...instance.data?.project.instances.map((instance2) => ({
      id: instance2.slug,
      label: instance2.name
    })) ?? [], ...!instance.data?.project.instances.some((i) => i.type == "production") ? [{
      id: "__production_instance__",
      label: "Production"
    }] : [], {
      type: "separator"
    }, {
      id: "__new_instance__",
      label: "Create Instance"
    }], onItemClick: async (id) => {
      if (id == "__production_instance__") {
        let res = await createInstanceMutator.mutate({
          name: "Production",
          type: "production",
          projectId: instance.data?.project.id
        });
        if (res)
          navigate(getRoute("instance_home", {
            instanceSlug: res.slug
          }));
      } else if (id == "__new_instance__") {
        createInstance({
          project: instance.data?.project,
          workspaceProduct: (await bootWorkspace({
            workspaceId: instance.data?.project.workspaceId
          })).productWorkspace
        });
      } else {
        navigate(getRoute("instance_home", {
          instanceSlug: id
        }));
      }
    }, children: /* @__PURE__ */ jsxs7(TitleButton, { children: [
      /* @__PURE__ */ jsx8("span", { children: instance.data?.instance.name }),
      /* @__PURE__ */ jsx8(RiArrowDownSLine, { size: 16 })
    ] }) }) }) }) }) }),
    children
  ] });
};

// src/layouts/largePane.tsx
import { theme as theme9 } from "@lb-lib/ui";
import styled12, { keyframes as keyframes3 } from "styled-components";

// src/layouts/rootLayout.tsx
import styled11 from "styled-components";

// src/navigation/nav.tsx
import { dynamicComponent as dynamicComponent8 } from "@lb-lib/dynamic-component";
import { Button as Button6, theme as theme8 } from "@lb-lib/ui";
import { useCurrentOrganization, useSession as useSession2, useShell as useShell5 } from "@loopbound-ares/state";
import { RiSettings2Line } from "@remixicon/react";
import { Search as SearchIcon } from "react-feather";
import { Link as Link4 } from "react-router-dom";
import styled10 from "styled-components";

// src/navigation/switchers/switcherHorizontal.tsx
import { Avatar, LinkButton as LinkButton3, Text as Text4, theme as theme5 } from "@lb-lib/ui";
import { bootWorkspace as bootWorkspace2, useOrganizations, useShell as useShell2 } from "@loopbound-ares/state";
import * as Popover from "@radix-ui/react-popover";
import { RiArrowRightSLine } from "@remixicon/react";
import { useEffect as useEffect2, useState as useState4 } from "react";
import { useLocation as useLocation2, useNavigate as useNavigate2, useParams } from "react-router-dom";
import styled7 from "styled-components";

// src/navigation/switchers/animations.tsx
import { keyframes } from "styled-components";
var fadeIn = keyframes`from{opacity:0;}to{opacity:1;}`;
var fadeOut = keyframes`from{opacity:1;}to{opacity:0;}`;

// src/navigation/switchers/switcherHorizontal.tsx
import { Fragment as Fragment6, jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var TriggerWrapper = styled7.button.withConfig({
  componentId: "sc-yzr5mx-0"
})`display:flex;height:50px;padding:5px 10px;transition:all 0.2s ease;border:none;background:transparent;outline:none;align-items:center;border-radius:10px;width:fit-content;&:hover,&:focus{background:${theme5.colors.gray400};}`;
var TriggerInner = styled7.div.withConfig({
  componentId: "sc-yzr5mx-1"
})`display:flex;gap:10px;align-items:center;`;
var TriggerEntityWrapper = styled7.div.withConfig({
  componentId: "sc-yzr5mx-2"
})`display:flex;max-width:min(180px,100%);gap:10px;align-items:center;`;
var TriggerSectionEntityText = styled7.p.withConfig({
  componentId: "sc-yzr5mx-3"
})`white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;flex-shrink:1;flex-grow:1;font-size:12px;font-weight:500;text-align:left;`;
var TriggerEntity = ({
  entity,
  height = 40
}) => {
  return /* @__PURE__ */ jsxs8(TriggerEntityWrapper, { style: {
    height
  }, children: [
    entity.imageUrl && /* @__PURE__ */ jsx9("div", { style: {
      flexShrink: 0
    }, children: /* @__PURE__ */ jsx9(Avatar, { entity, size: height * 0.85, noTooltip: true }) }),
    /* @__PURE__ */ jsx9(TriggerSectionEntityText, { children: entity.name })
  ] });
};
var TriggerArrow = () => {
  return /* @__PURE__ */ jsx9("div", { style: {
    width: 16,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: 0.3
  }, children: /* @__PURE__ */ jsx9(RiArrowRightSLine, { size: 16 }) });
};
var PopoverContent = styled7(Popover.Content).withConfig({
  componentId: "sc-yzr5mx-4"
})`background:${theme5.colors.background};border:1px solid ${theme5.colors.gray300};border-radius:10px;overflow:hidden;background:${theme5.colors.background};box-shadow:${theme5.shadows.large};z-index:9999;max-height:50vh;padding:0;&[data-state='open']{animation:${fadeIn} 0.3s;}&[data-state='closed']{animation:${fadeOut} 0.3s;}`;
var PopoverHeader = styled7("header").withConfig({
  componentId: "sc-yzr5mx-5"
})`border-bottom:1px solid ${theme5.colors.gray300};padding:4px 9px;display:flex;`;
var PopoverGrid = styled7("main").withConfig({
  componentId: "sc-yzr5mx-6"
})`background:${theme5.colors.gray300};height:350px;display:grid;gap:1px;`;
var PopoverPart = styled7("section").withConfig({
  componentId: "sc-yzr5mx-7"
})`background:${theme5.colors.background};width:200px;display:flex;flex-direction:column;overflow:hidden;`;
var PopoverItems = styled7("div").withConfig({
  componentId: "sc-yzr5mx-8"
})`padding:10px;overflow:auto;height:400px;display:flex;flex-direction:column;gap:5px;`;
var PopoverButton = styled7("button").withConfig({
  componentId: "sc-yzr5mx-9"
})`padding:0;border:none;background:none;outline:none;border-radius:7px;padding:5px 10px;&:hover,&:focus{background:${theme5.colors.gray300};}p{font-size:14px !important;}`;
var PopoverSectionFooter = styled7("footer").withConfig({
  componentId: "sc-yzr5mx-10"
})`position:sticky;bottom:0;display:flex;flex-direction:column;border-top:1px solid ${theme5.colors.gray300};padding:10px;`;
var PopoverInner = ({
  triggerInner,
  currentOrg,
  currentProject,
  currentInstance,
  currentWorkspace,
  close
}) => {
  let orgs = useOrganizations();
  let navigate = useNavigate2();
  let context = useShell2();
  let [selectedOrg, setSelectedOrg] = useState4(null);
  let [selectedWorkspace, setSelectedWorkspace] = useState4(null);
  let [selectedProject, setSelectedProject] = useState4(null);
  let [selectedInstance, setSelectedInstance] = useState4(null);
  let selectedProductWorkspace = selectedWorkspace?.productWorkspaces.find(
    // @ts-ignore
    (p) => p.product == context.product.id
  );
  useEffect2(() => {
    if (currentOrg)
      setSelectedOrg(currentOrg);
  }, [currentOrg]);
  useEffect2(() => {
    if (currentProject)
      setSelectedProject(currentProject);
  }, [currentProject]);
  useEffect2(() => {
    if (currentInstance)
      setSelectedInstance(currentInstance);
  }, [currentInstance]);
  useEffect2(() => {
    if (currentWorkspace)
      setSelectedWorkspace(currentWorkspace);
  }, [currentWorkspace]);
  let selectOrg = (org) => {
    navigate(routes.organization_settings_home({
      organizationSlug: org.slug
    }));
    close();
  };
  let selectWorkspace = (workspace) => {
    setSelectedWorkspace(workspace);
    let org = orgs.data.find((o) => o.organization.id == workspace.organizationId)?.organization;
    if (org)
      setSelectedOrg(org);
    let productWorkspace = workspace.productWorkspaces.find(
      // @ts-ignore
      (p) => p.product == context.product.id
    );
    let firstProject = orgs.data.flatMap((o) => o.projects).find((p) => p.workspaceProductId == productWorkspace?.id);
    if (firstProject) {
      setSelectedProject(firstProject);
      setSelectedInstance(firstProject?.instances[0]);
    } else {
      setSelectedProject(null);
      setSelectedInstance(null);
    }
  };
  let selectProject = (project) => {
    if (project.id == currentProject?.id)
      return;
    let instance = project.instances[0];
    selectInstance(instance);
  };
  let selectInstance = (instance) => {
    let project = orgs.data.flatMap((o) => o.projects).find((p) => p.instances.some((i) => i.id == instance.id));
    let workspace = orgs.data.flatMap((o) => o.workspaces).find((w) => w.id == project?.workspaceId);
    if (!project || !workspace)
      return;
    navigate(routes.instance_home({
      instanceSlug: instance.slug
    }));
    close();
  };
  let workspaces = orgs.data.flatMap(({
    workspaces: workspaces2
  }) => workspaces2);
  let projects = orgs.data.flatMap(({
    projects: projects2
  }) => projects2).filter((project) => project.workspaceProductId == selectedProductWorkspace?.id);
  let instances = orgs.data.flatMap(({
    projects: projects2
  }) => projects2).flatMap(({
    instances: instances2
  }) => instances2).filter((instance) => instance.projectId == selectedProject?.id);
  let doCreateProject = async () => {
    if (!selectedWorkspace)
      return;
    let {
      productWorkspace
    } = await bootWorkspace2({
      workspaceId: selectedWorkspace.id
    });
    createProject2({
      workspaceProduct: productWorkspace,
      redirectOnCreate: true
    });
  };
  return /* @__PURE__ */ jsxs8(Fragment6, { children: [
    /* @__PURE__ */ jsx9(PopoverHeader, { children: triggerInner }),
    /* @__PURE__ */ jsx9(PopoverGrid, { style: {
      gridTemplateColumns: new Array(!currentInstance ? 1 : context.layout.instanceSwitcher ? 3 : 2).fill("1fr").join(" ")
    }, children: !currentInstance ? /* @__PURE__ */ jsxs8(PopoverPart, { style: {
      width: 300
    }, children: [
      /* @__PURE__ */ jsx9(PopoverItems, { children: orgs.data.map(({
        organization
      }) => /* @__PURE__ */ jsx9(PopoverButton, { onClick: () => selectOrg(organization), children: /* @__PURE__ */ jsx9(TriggerEntity, { entity: organization, height: 30 }) }, organization.id)) }),
      /* @__PURE__ */ jsx9(PopoverSectionFooter, { children: /* @__PURE__ */ jsx9(PopoverButton, { onClick: () => createOrganization2(), children: /* @__PURE__ */ jsx9(TriggerEntity, { entity: {
        name: "Create Organization"
      }, height: 30 }) }) })
    ] }) : /* @__PURE__ */ jsxs8(Fragment6, { children: [
      /* @__PURE__ */ jsxs8(PopoverPart, { children: [
        /* @__PURE__ */ jsx9(PopoverItems, { children: workspaces.map((workspace) => /* @__PURE__ */ jsx9(PopoverButton, { onClick: () => selectWorkspace(workspace), children: /* @__PURE__ */ jsx9(TriggerEntity, { entity: workspace }) }, workspace.id)) }),
        /* @__PURE__ */ jsx9(PopoverSectionFooter, { children: /* @__PURE__ */ jsx9(PopoverButton, { onClick: () => createOrganization2(), children: /* @__PURE__ */ jsx9(TriggerEntity, { entity: {
          name: "Create Organization"
        }, height: 30 }) }) })
      ] }),
      /* @__PURE__ */ jsxs8(PopoverPart, { children: [
        /* @__PURE__ */ jsxs8(PopoverItems, { children: [
          projects.map((project) => /* @__PURE__ */ jsx9(PopoverButton, { onClick: () => selectProject(project), children: /* @__PURE__ */ jsx9(TriggerEntity, { entity: project }) }, project.id)),
          projects.length == 0 && /* @__PURE__ */ jsxs8(Text4, { size: "2", weight: "medium", color: "gray600", children: [
            "You don't have any projects in this workspace yet. Get started by",
            " ",
            /* @__PURE__ */ jsx9(LinkButton3, { onClick: doCreateProject, children: "creating a project" }),
            "."
          ] })
        ] }),
        /* @__PURE__ */ jsx9(PopoverSectionFooter, { children: /* @__PURE__ */ jsx9(PopoverButton, { onClick: doCreateProject, children: /* @__PURE__ */ jsx9(TriggerEntity, { entity: {
          name: "Create Project"
        }, height: 30 }) }) })
      ] }),
      context.layout.instanceSwitcher && /* @__PURE__ */ jsx9(PopoverPart, { children: selectedProject && /* @__PURE__ */ jsxs8(Fragment6, { children: [
        /* @__PURE__ */ jsx9(PopoverItems, { children: instances.map((instance) => /* @__PURE__ */ jsx9(PopoverButton, { onClick: () => selectInstance(instance), children: /* @__PURE__ */ jsx9(TriggerEntity, { entity: instance }) }, instance.id)) }),
        /* @__PURE__ */ jsx9(PopoverSectionFooter, { children: /* @__PURE__ */ jsx9(PopoverButton, { onClick: async () => {
          if (!selectedWorkspace || !selectedProject)
            return;
          let {
            productWorkspace
          } = await bootWorkspace2({
            workspaceId: selectedWorkspace.id
          });
          createInstance({
            workspaceProduct: productWorkspace,
            project: selectedProject,
            redirectOnCreate: true
          });
        }, children: /* @__PURE__ */ jsx9(TriggerEntity, { entity: {
          name: "Create Instance"
        }, height: 30 }) }) })
      ] }) })
    ] }) })
  ] });
};
var SwitcherHorizontal = ({
  logo,
  enabled
}) => {
  let orgs = useOrganizations();
  let [open, setOpen] = useState4(false);
  let {
    organizationId,
    instanceId
  } = useParams();
  let context = useShell2();
  let {
    pathname
  } = useLocation2();
  useEffect2(() => setOpen(false), [pathname]);
  let currentOrg = orgs.data?.find((org) => org.organization.id == organizationId || org.organization.slug == organizationId || org.projects.some((p) => p.instances.some((i) => i.id == instanceId || i.slug == instanceId)));
  let pageType = !currentOrg ? "global" : organizationId ? "organization" : "instance";
  let currentProject = currentOrg?.projects.find((p) => p.instances.some((i) => i.id == instanceId || i.slug == instanceId));
  let currentInstance = currentProject?.instances.find((i) => i.id == instanceId || i.slug == instanceId);
  let currentWorkspace = currentOrg?.workspaces.find((w) => w.id == currentProject?.workspaceId);
  if (pageType == "global" || !currentOrg || enabled === false)
    return /* @__PURE__ */ jsx9(TriggerWrapper, { as: "div", children: /* @__PURE__ */ jsx9(TriggerInner, { children: logo }) });
  let triggerInner = /* @__PURE__ */ jsxs8(TriggerInner, { children: [
    logo,
    /* @__PURE__ */ jsx9(TriggerArrow, {}),
    /* @__PURE__ */ jsx9(TriggerEntity, { entity: currentOrg.organization }),
    currentProject && currentInstance && /* @__PURE__ */ jsxs8(Fragment6, { children: [
      /* @__PURE__ */ jsx9(TriggerArrow, {}),
      /* @__PURE__ */ jsx9(TriggerEntity, { entity: currentProject }),
      context.layout.instanceSwitcher && /* @__PURE__ */ jsxs8(Fragment6, { children: [
        /* @__PURE__ */ jsx9(TriggerArrow, {}),
        /* @__PURE__ */ jsx9(TriggerEntity, { entity: currentInstance })
      ] })
    ] })
  ] });
  return /* @__PURE__ */ jsx9("div", { children: /* @__PURE__ */ jsxs8(Popover.Root, { open, onOpenChange: setOpen, children: [
    /* @__PURE__ */ jsx9(Popover.Trigger, { asChild: true, children: /* @__PURE__ */ jsx9(TriggerWrapper, { children: triggerInner }) }),
    /* @__PURE__ */ jsx9(PopoverContent, { side: "bottom", align: "start", sideOffset: -50, children: /* @__PURE__ */ jsx9(PopoverInner, { triggerInner, currentOrg: currentOrg.organization, currentProject, currentInstance, currentWorkspace, close: () => setOpen(false) }) })
  ] }) });
};

// src/navigation/switchers/switcherVertical.tsx
import { Badge, Button as Button4, Spacer as Spacer2, Text as Text5, theme as theme6 } from "@lb-lib/ui";
import { getServiceUrl, useCurrentBootWorkspace as useCurrentBootWorkspace2, useCurrentInstance as useCurrentInstance6, useCurrentWorkspace, useOrganizations as useOrganizations2, useShell as useShell3 } from "@loopbound-ares/state";
import * as Popover2 from "@radix-ui/react-popover";
import { RiAddLine as RiAddLine2, RiArrowDownSLine as RiArrowDownSLine2, RiArrowLeftLine, RiArrowRightLine, RiFlashlightLine } from "@remixicon/react";
import { AnimatePresence, motion } from "framer-motion";
import { useState as useState5 } from "react";
import { Link as Link2 } from "react-router-dom";
import styled8 from "styled-components";
import { Fragment as Fragment7, jsx as jsx10, jsxs as jsxs9 } from "react/jsx-runtime";
var Wrapper7 = styled8("section").withConfig({
  componentId: "sc-d72u2y-0"
})`display:flex;flex-direction:column;padding:5px;background:${theme6.colors.gray400};border-radius:10px;`;
var Trigger3 = styled8("button").withConfig({
  componentId: "sc-d72u2y-1"
})`display:flex;border:none;background:none;padding:0px;`;
var TriggerContent = styled8("div").withConfig({
  shouldForwardProp: (prop) => !["withHover"].includes(prop)
}).withConfig({
  componentId: "sc-d72u2y-2"
})`padding:10px;display:flex;gap:10px;align-items:center;border:none;background:none;flex-grow:1;color:${theme6.colors.gray700};transition:background 0.1s;${(p) => p.withHover ? `
  &:hover, &:focus {
    background: ${theme6.colors.gray200};
  }
  ` : ""}`;
var WorkspaceTrigger = styled8(Trigger3).withConfig({
  componentId: "sc-d72u2y-3"
})`background:${theme6.colors.background};border-radius:7px;box-shadow:${theme6.shadows.medium};`;
var InstanceTrigger = styled8(Trigger3).withConfig({
  componentId: "sc-d72u2y-4"
})``;
var Image = styled8("img").withConfig({
  componentId: "sc-d72u2y-5"
})`width:30px;height:30px;border-radius:50%;`;
var Name = styled8("p").withConfig({
  componentId: "sc-d72u2y-6"
})`font-size:14px;font-weight:500;color:${theme6.colors.gray800};display:flex;align-items:center;flex-grow:1;line-height:1;`;
var ProjectName = styled8(Name).withConfig({
  componentId: "sc-d72u2y-7"
})`font-size:12px;color:${theme6.colors.gray600};`;
var PopoverContent2 = styled8(Popover2.Content).withConfig({
  componentId: "sc-d72u2y-8"
})`background:${theme6.colors.background};border-radius:8px;box-shadow:${theme6.shadows.large};width:270px;overflow:hidden;z-index:9999;max-height:50vh;overflow-y:auto;&[data-state='open']{animation:${fadeIn} 0.3s;}&[data-state='closed']{animation:${fadeOut} 0.3s;}`;
var Group = styled8("div").withConfig({
  componentId: "sc-d72u2y-9"
})`display:flex;flex-direction:column;&:not(:last-child){border-bottom:1px solid ${theme6.colors.gray300};}`;
var IconWrapper = styled8("div").withConfig({
  componentId: "sc-d72u2y-10"
})`width:30px;height:30px;border-radius:50%;background:${theme6.colors.gray400};display:flex;align-items:center;justify-content:center;`;
var WorkspaceHeader = ({
  withHover = false
}) => {
  let workspace = useCurrentWorkspace();
  let instance = useCurrentInstance6();
  return /* @__PURE__ */ jsxs9(TriggerContent, { withHover, children: [
    /* @__PURE__ */ jsx10(Image, { src: workspace.data?.imageUrl, alt: workspace.data?.name }),
    /* @__PURE__ */ jsxs9("div", { style: {
      display: "flex",
      flexDirection: "column",
      gap: "3px",
      flexGrow: 1
    }, children: [
      /* @__PURE__ */ jsx10(Name, { children: workspace.data?.name }),
      /* @__PURE__ */ jsx10(ProjectName, { children: instance.data?.project.name })
    ] }),
    /* @__PURE__ */ jsx10(RiArrowDownSLine2, { size: 16 })
  ] });
};
var Workspace2 = () => {
  let organizations = useOrganizations2();
  let workspace = useCurrentWorkspace();
  let organization = organizations.data.find((o) => o.organization.id == workspace.data?.organizationId)?.organization;
  let shell = useShell3();
  let workspaces = organizations.data.flatMap((o) => o.workspaces);
  let projects = organizations.data.flatMap((o) => o.projects);
  let [isOpen, setIsOpen] = useState5(false);
  return /* @__PURE__ */ jsxs9(Popover2.Root, { open: isOpen, onOpenChange: setIsOpen, children: [
    /* @__PURE__ */ jsx10(Popover2.Trigger, { asChild: true, children: /* @__PURE__ */ jsx10(WorkspaceTrigger, { "aria-label": "Select workspace", style: {
      opacity: workspace.data ? 1 : 0
    }, disabled: !workspaces.length, children: /* @__PURE__ */ jsx10(WorkspaceHeader, {}) }) }),
    /* @__PURE__ */ jsx10(Popover2.Portal, { children: /* @__PURE__ */ jsx10(PopoverContent2, { sideOffset: -50, side: "bottom", children: workspace.data && /* @__PURE__ */ jsxs9(Fragment7, { children: [
      /* @__PURE__ */ jsxs9(Group, { children: [
        /* @__PURE__ */ jsx10(Popover2.Close, { asChild: true, children: /* @__PURE__ */ jsx10(WorkspaceTrigger, { style: {
          boxShadow: "none"
        }, children: /* @__PURE__ */ jsx10(WorkspaceHeader, {}) }) }),
        /* @__PURE__ */ jsxs9("div", { style: {
          display: "flex",
          flexDirection: "column",
          gap: "7px",
          padding: "0px 10px 10px 10px"
        }, children: [
          /* @__PURE__ */ jsx10(Link2, { to: getServiceUrl("admin", routes.organization_settings_general({
            organizationSlug: organization?.slug
          })), children: /* @__PURE__ */ jsx10(Button4, { as: "span", variant: "outline", fullWidth: true, size: "2", children: "Settings" }) }),
          /* @__PURE__ */ jsx10(Link2, { to: getServiceUrl("admin", routes.organization_settings_members({
            organizationSlug: organization?.slug
          })), children: /* @__PURE__ */ jsx10(Button4, { as: "span", variant: "outline", fullWidth: true, size: "2", children: "Members" }) })
        ] })
      ] }),
      workspaces.map((w) => {
        let productWorkspace = w.productWorkspaces.find((p) => p.product == shell.product.id);
        let currentProjects = projects.filter((p) => p.workspaceProductId == productWorkspace?.id);
        return /* @__PURE__ */ jsxs9(Group, { children: [
          /* @__PURE__ */ jsxs9(TriggerContent, { children: [
            /* @__PURE__ */ jsx10(Image, { src: w.imageUrl, alt: w.name }),
            /* @__PURE__ */ jsx10(Name, { children: w.name }),
            /* @__PURE__ */ jsx10(RiArrowDownSLine2, { size: 16 })
          ] }),
          currentProjects.map((p) => {
            let instance = p.instances.find((i) => i.environment.type == "development") ?? p.instances[0];
            return /* @__PURE__ */ jsx10("a", { href: routes.instance_home({
              instanceSlug: instance.slug
            }), onClick: () => setIsOpen(false), children: /* @__PURE__ */ jsxs9(TriggerContent, { withHover: true, children: [
              /* @__PURE__ */ jsx10(Spacer2, { width: 30 }),
              /* @__PURE__ */ jsx10(Name, { children: p.name }),
              /* @__PURE__ */ jsx10(RiArrowRightLine, { size: 16 })
            ] }) }, p.id);
          }),
          /* @__PURE__ */ jsx10("button", { onClick: () => productWorkspace && createProject({
            redirectOnCreate: true,
            workspaceProduct: productWorkspace
          }), style: {
            border: "none",
            background: "none",
            padding: 0,
            cursor: "pointer"
          }, children: /* @__PURE__ */ jsxs9(TriggerContent, { withHover: true, children: [
            /* @__PURE__ */ jsx10(Spacer2, { width: 30 }),
            /* @__PURE__ */ jsx10(Name, { children: "Create Project" }),
            /* @__PURE__ */ jsx10(RiAddLine2, { size: 16 })
          ] }) })
        ] }, w.id);
      }),
      /* @__PURE__ */ jsx10(Group, { children: /* @__PURE__ */ jsx10("button", { onClick: () => createOrganization(), style: {
        border: "none",
        background: "none",
        padding: 0,
        cursor: "pointer"
      }, children: /* @__PURE__ */ jsxs9(TriggerContent, { withHover: true, children: [
        /* @__PURE__ */ jsx10(IconWrapper, { children: /* @__PURE__ */ jsx10(RiAddLine2, { size: 16 }) }),
        /* @__PURE__ */ jsx10(Name, { children: "Create Organization" }),
        /* @__PURE__ */ jsx10(RiArrowRightLine, { size: 16 })
      ] }) }) })
    ] }) }) })
  ] });
};
var InstanceHeader = ({
  withHover = false,
  type
}) => {
  let instance = useCurrentInstance6();
  return /* @__PURE__ */ jsxs9(TriggerContent, { withHover, style: {
    height: 55
  }, children: [
    /* @__PURE__ */ jsx10(IconWrapper, { children: /* @__PURE__ */ jsx10(RiFlashlightLine, { size: 16 }) }),
    /* @__PURE__ */ jsx10("div", { style: {
      display: "flex",
      flexDirection: "column",
      gap: "5px",
      flexGrow: 1
    }, children: /* @__PURE__ */ jsx10(Name, { children: instance.data?.instance.name }) }),
    type == "expand" && /* @__PURE__ */ jsx10(RiArrowDownSLine2, { size: 16 }),
    type == "select" && /* @__PURE__ */ jsx10(RiArrowRightLine, { size: 16 })
  ] });
};
var Instance2 = () => {
  let workspace = useCurrentBootWorkspace2();
  let instance = useCurrentInstance6();
  let instances = workspace.data?.projects.find((p) => p.id == instance.data?.project.id)?.instances ?? [];
  let [isOpen, setIsOpen] = useState5(false);
  return /* @__PURE__ */ jsxs9(Popover2.Root, { open: isOpen, onOpenChange: setIsOpen, children: [
    /* @__PURE__ */ jsx10(Popover2.Trigger, { asChild: true, children: /* @__PURE__ */ jsx10(InstanceTrigger, { "aria-label": "Select workspace", style: {
      opacity: workspace.data ? 1 : 0
    }, disabled: !instance.data, children: /* @__PURE__ */ jsx10(InstanceHeader, { type: "expand" }) }) }),
    /* @__PURE__ */ jsx10(Popover2.Portal, { children: /* @__PURE__ */ jsx10(PopoverContent2, { sideOffset: -55, side: "bottom", children: instance.data && /* @__PURE__ */ jsxs9(Fragment7, { children: [
      instances.map((i) => /* @__PURE__ */ jsx10(Group, { children: /* @__PURE__ */ jsx10(Link2, { to: routes.instance_home({
        instanceSlug: i.slug
      }), onClick: () => setIsOpen(false), children: /* @__PURE__ */ jsxs9(TriggerContent, { withHover: true, style: {
        height: 55
      }, children: [
        /* @__PURE__ */ jsx10(IconWrapper, { children: /* @__PURE__ */ jsx10(RiFlashlightLine, { size: 16 }) }),
        /* @__PURE__ */ jsx10("div", { style: {
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          flexGrow: 1
        }, children: /* @__PURE__ */ jsx10(Name, { children: i.name }) }),
        /* @__PURE__ */ jsx10(RiArrowRightLine, { size: 16 })
      ] }) }) }, i.id)),
      /* @__PURE__ */ jsx10(Group, { children: /* @__PURE__ */ jsx10("button", { onClick: () => workspace.data?.productWorkspace && instance.data?.project && createInstance({
        workspaceProduct: workspace.data.productWorkspace,
        project: instance.data.project
      }), style: {
        border: "none",
        background: "none",
        padding: 0,
        cursor: "pointer"
      }, children: /* @__PURE__ */ jsxs9(TriggerContent, { withHover: true, children: [
        /* @__PURE__ */ jsx10(IconWrapper, { children: /* @__PURE__ */ jsx10(RiAddLine2, { size: 16 }) }),
        /* @__PURE__ */ jsx10(Name, { children: "Create Instance" }),
        /* @__PURE__ */ jsx10(RiArrowRightLine, { size: 16 })
      ] }) }) }),
      /* @__PURE__ */ jsxs9(TriggerContent, { style: {
        position: "sticky",
        bottom: 0,
        background: theme6.colors.background
      }, children: [
        /* @__PURE__ */ jsx10(Badge, { color: "blue", size: "1", children: "Tip" }),
        " ",
        /* @__PURE__ */ jsx10(Text5, { size: "1", color: "gray600", weight: "medium", children: "Instances are isolated environments you can use to separate production, staging, and development environments." })
      ] })
    ] }) }) })
  ] });
};
var Outer = styled8(motion.div).withConfig({
  componentId: "sc-d72u2y-11"
})`padding:10px;position:relative;`;
var SwitcherVertical = () => {
  let [hovered, setHovered] = useState5(false);
  return /* @__PURE__ */ jsx10(Outer, { style: {
    padding: "0px 10px"
  }, initial: {
    opacity: 0,
    y: 10
  }, animate: {
    opacity: 1,
    y: 0
  }, onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), children: /* @__PURE__ */ jsxs9(Wrapper7, { children: [
    /* @__PURE__ */ jsx10(AnimatePresence, { children: hovered && /* @__PURE__ */ jsxs9(motion.div, { initial: {
      opacity: 0,
      y: -10,
      height: 0
    }, animate: {
      opacity: 1,
      y: 0,
      height: "auto"
    }, exit: {
      opacity: 0,
      y: -10,
      height: 0
    }, style: {
      overflow: "hidden"
    }, children: [
      /* @__PURE__ */ jsx10(Link2, { to: "/", children: /* @__PURE__ */ jsx10("div", { children: /* @__PURE__ */ jsx10(Button4, { iconLeft: /* @__PURE__ */ jsx10(RiArrowLeftLine, {}), size: "1", as: "div", children: "Back to Overview" }) }) }),
      /* @__PURE__ */ jsx10(Spacer2, { height: 5 })
    ] }) }),
    /* @__PURE__ */ jsx10(Workspace2, {}),
    /* @__PURE__ */ jsx10(Spacer2, { height: 5 }),
    /* @__PURE__ */ jsx10(Instance2, {})
  ] }) });
};

// src/navigation/user.tsx
import { Button as Button5, Text as Text6, theme as theme7 } from "@lb-lib/ui";
import { getServiceUrl as getServiceUrl2, logout, redirectToUserSelector as redirectToUserSelector2, useSession, useShell as useShell4 } from "@loopbound-ares/state";
import * as Popover3 from "@radix-ui/react-popover";
import { Link as Link3 } from "react-router-dom";
import styled9, { keyframes as keyframes2 } from "styled-components";
import { jsx as jsx11, jsxs as jsxs10 } from "react/jsx-runtime";
var Wrapper8 = styled9("section").withConfig({
  componentId: "sc-122dlvv-0"
})`display:flex;flex-direction:column;align-items:center;height:30px;background:${theme7.colors.gray300};border-radius:10px;gap:5px;padding-right:7px;`;
var Trigger5 = styled9("button").withConfig({
  componentId: "sc-122dlvv-1"
})`display:flex;border:none;background:none;padding:0px;`;
var TriggerContent2 = styled9("div").withConfig({
  componentId: "sc-122dlvv-2"
})`padding:25px 10px 10px 10px;display:flex;gap:15px;align-items:center;flex-direction:column;text-align:center;border:none;background:none;flex-grow:1;color:${theme7.colors.gray700};transition:background 0.1s;`;
var UserTrigger = styled9(Trigger5).withConfig({
  componentId: "sc-122dlvv-3"
})`border-radius:7px;display:flex;gap:10px;align-items:center;`;
var Image2 = styled9("img").withConfig({
  componentId: "sc-122dlvv-4"
})`width:30px;height:30px;border-radius:50%;`;
var Name2 = styled9("p").withConfig({
  componentId: "sc-122dlvv-5"
})`font-size:18px;font-weight:500;color:${theme7.colors.gray800};`;
var Email = styled9("p").withConfig({
  componentId: "sc-122dlvv-6"
})`font-size:12px;font-weight:500;color:${theme7.colors.gray600};margin-top:3px;`;
var fadeIn2 = keyframes2`from{opacity:0;}to{opacity:1;}`;
var fadeOut2 = keyframes2`from{opacity:1;}to{opacity:0;}`;
var PopoverContent3 = styled9(Popover3.Content).withConfig({
  componentId: "sc-122dlvv-7"
})`background:${theme7.colors.background};border-radius:12px;box-shadow:${theme7.shadows.large};width:270px;overflow:hidden;z-index:9999;&[data-state='open']{animation:${fadeIn2} 0.3s;}&[data-state='closed']{animation:${fadeOut2} 0.3s;}`;
var Group2 = styled9("div").withConfig({
  componentId: "sc-122dlvv-8"
})`display:flex;flex-direction:column;&:not(:last-child){border-bottom:1px solid ${theme7.colors.gray300};}`;
var OtherUser = styled9("button").withConfig({
  componentId: "sc-122dlvv-9"
})`display:flex;gap:10px;align-items:center;cursor:pointer;padding:0px;border:none;background:none;`;
var UserHeader = () => {
  let session = useSession();
  return /* @__PURE__ */ jsxs10(TriggerContent2, { children: [
    /* @__PURE__ */ jsx11(Image2, { style: {
      width: "70px",
      height: "70px"
    }, src: session?.user?.imageUrl, alt: session?.user?.name }),
    /* @__PURE__ */ jsxs10("div", { children: [
      /* @__PURE__ */ jsx11(Name2, { children: session?.user?.name }),
      /* @__PURE__ */ jsx11(Email, { children: session?.user?.email })
    ] })
  ] });
};
var User = () => {
  let session = useSession();
  let shell = useShell4();
  let otherUsers = session?.sessionUsers.filter((u) => u.userId !== session?.user?.id) ?? [];
  return /* @__PURE__ */ jsx11(Wrapper8, { children: /* @__PURE__ */ jsxs10(Popover3.Root, { children: [
    /* @__PURE__ */ jsx11(Popover3.Trigger, { asChild: true, children: /* @__PURE__ */ jsxs10(UserTrigger, { "aria-label": "Your profile", children: [
      /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(Image2, { src: session?.user?.imageUrl, alt: session?.user?.name, title: "Open user menu", style: {
        cursor: "pointer",
        opacity: session?.user?.imageUrl ? 1 : 0,
        transition: "opacity 0.2s"
      } }) }),
      /* @__PURE__ */ jsx11(Text6, { size: "1", weight: "strong", color: "gray800", children: session?.user?.firstName ?? session?.user?.name })
    ] }) }),
    /* @__PURE__ */ jsx11(Popover3.Portal, { children: /* @__PURE__ */ jsx11(PopoverContent3, { sideOffset: 10, side: "bottom", children: /* @__PURE__ */ jsxs10(Group2, { children: [
      /* @__PURE__ */ jsx11(Popover3.Close, { asChild: true, children: /* @__PURE__ */ jsx11(UserTrigger, { style: {
        boxShadow: "none"
      }, children: /* @__PURE__ */ jsx11(UserHeader, {}) }) }),
      /* @__PURE__ */ jsxs10("div", { style: {
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        padding: "15px 20px 20px 20px"
      }, children: [
        /* @__PURE__ */ jsx11(Link3, { to: getServiceUrl2("account"), children: /* @__PURE__ */ jsx11(Button5, { as: "span", variant: "outline", fullWidth: true, size: "2", children: "Account" }) }),
        /* @__PURE__ */ jsx11(Button5, { variant: "outline", fullWidth: true, size: "2", onClick: () => {
          logout();
        }, children: "Logout" })
      ] }),
      /* @__PURE__ */ jsxs10("div", { style: {
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        padding: "20px",
        borderTop: `1px solid ${theme7.colors.gray300}`,
        maxHeight: "300px",
        overflowY: "auto"
      }, children: [
        otherUsers.length > 0 && /* @__PURE__ */ jsx11(Text6, { color: "gray600", weight: "medium", size: "1", children: "Change account" }),
        /* @__PURE__ */ jsxs10("div", { style: {
          display: "flex",
          flexDirection: "column",
          gap: "10px"
        }, children: [
          otherUsers.map(({
            user
          }) => /* @__PURE__ */ jsxs10(OtherUser, { onClick: () => {
            redirectToUserSelector2(user.id);
          }, children: [
            /* @__PURE__ */ jsx11(Image2, { src: user.imageUrl, alt: user.name, style: {
              width: "30px",
              height: "30px",
              borderRadius: "50%"
            } }),
            /* @__PURE__ */ jsxs10("div", { children: [
              /* @__PURE__ */ jsx11(Text6, { weight: "medium", size: "2", children: user.name }),
              /* @__PURE__ */ jsx11(Text6, { color: "gray600", weight: "medium", size: "1", children: user.email })
            ] })
          ] }, user.id)),
          /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(Button5, { variant: "soft", size: "1", fullWidth: !otherUsers.length, onClick: () => {
            redirectToUserSelector2();
          }, children: "Log in with a different account" }) })
        ] })
      ] })
    ] }) }) })
  ] }) });
};

// src/navigation/nav.tsx
import { jsx as jsx12, jsxs as jsxs11 } from "react/jsx-runtime";
var Notifications = dynamicComponent8(async () => (await import("./notifications-Q226KUXX.js")).Notifications);
var Wrapper9 = styled10("header").withConfig({
  componentId: "sc-2wjexc-0"
})`padding:5px;`;
var Inner2 = styled10("nav").withConfig({
  componentId: "sc-2wjexc-1"
})`display:grid;gap:15px;height:50px;`;
var Part = styled10("div").withConfig({
  componentId: "sc-2wjexc-2"
})`height:100%;display:flex;align-items:center;`;
var LogoPart = styled10(Part).withConfig({
  componentId: "sc-2wjexc-3"
})`width:30px;justify-content:flex-start;svg{height:30px;}`;
var SearchPart = styled10(Part).withConfig({
  componentId: "sc-2wjexc-4"
})`justify-content:center;`;
var SearchButton = styled10("button").withConfig({
  componentId: "sc-2wjexc-5"
})`height:40px;display:flex;align-items:center;padding:0 15px;border-radius:8px;background:${theme8.colors.gray400};border:none;gap:10px;font-size:14px;max-width:400px;width:100%;svg{height:16px;width:16px;}`;
var ActionsPart = styled10(Part).withConfig({
  componentId: "sc-2wjexc-6"
})`gap:15px;justify-content:flex-end;`;
var Nav = () => {
  let shell = useShell5();
  let auth = useSession2();
  let organization = useCurrentOrganization();
  let logo = /* @__PURE__ */ jsx12(Link4, { to: "/", children: /* @__PURE__ */ jsx12(LogoPart, { children: shell.logo }) });
  return /* @__PURE__ */ jsx12(Wrapper9, { style: {
    opacity: auth?.state != "loading" ? 1 : 0,
    transition: "opacity 0.2s"
  }, children: /* @__PURE__ */ jsxs11(Inner2, { style: {
    gridTemplateColumns: shell.search.enabled ? "1fr 3fr 1fr" : "1fr 1fr"
  }, children: [
    /* @__PURE__ */ jsx12(SwitcherHorizontal, { logo, enabled: shell.layout.horizontalSwitcher.enabled }),
    shell.search.enabled && /* @__PURE__ */ jsx12(SearchPart, { children: /* @__PURE__ */ jsxs11(SearchButton, { children: [
      /* @__PURE__ */ jsx12(SearchIcon, {}),
      /* @__PURE__ */ jsx12("span", { children: "Search" })
    ] }) }),
    /* @__PURE__ */ jsxs11(ActionsPart, { children: [
      organization.data?.organization && /* @__PURE__ */ jsx12(Link4, { to: routes.organization_settings_home({
        organizationSlug: organization.data?.organization.slug
      }), children: /* @__PURE__ */ jsx12(Button6, { variant: "ghost", size: "3", iconLeft: /* @__PURE__ */ jsx12(RiSettings2Line, { style: {
        height: 16,
        width: 16,
        color: theme8.colors.gray800
      } }), title: "Settings", as: "div" }) }),
      /* @__PURE__ */ jsx12(Notifications, {}),
      /* @__PURE__ */ jsx12(User, {})
    ] })
  ] }) });
};

// src/layouts/rootLayout.tsx
import { jsx as jsx13, jsxs as jsxs12 } from "react/jsx-runtime";
var Wrapper10 = styled11("div").withConfig({
  componentId: "sc-erocjl-0"
})``;
var RootLayout = ({
  children
}) => {
  return /* @__PURE__ */ jsxs12(Wrapper10, { children: [
    /* @__PURE__ */ jsx13(Nav, {}),
    children
  ] });
};

// src/layouts/largePane.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
var fadeIn3 = keyframes3`from{opacity:0;transform:translateY(20px);}to{opacity:1;transform:translateY(0);}`;
var Outer2 = styled12("div").withConfig({
  componentId: "sc-1ht5s4r-0"
})`padding:0px 10px 10px 10px;animation:${fadeIn3} 0.2s cubic-bezier(0.26,1.11,0.87,1.25);`;
var Wrapper11 = styled12("div").withConfig({
  componentId: "sc-1ht5s4r-1"
})`height:calc(100dvh - 70px);background:${theme9.colors.background};border-radius:10px;box-shadow:${theme9.shadows.large};overflow:auto;`;
var LargePaneLayout = ({
  children
}) => {
  return /* @__PURE__ */ jsx14(RootLayout, { children: /* @__PURE__ */ jsx14(Outer2, { children: /* @__PURE__ */ jsx14(Wrapper11, { children }) }) });
};

// src/layouts/workspacePane.tsx
import { Button as Button7, LargePanelDialog, showModal as showModal3, Spacer as Spacer3, Text as Text7, theme as theme10 } from "@lb-lib/ui";
import { SidebarItems } from "@loopbound-ares/components";
import { useBillingObject, useCurrentInstance as useCurrentInstance7 } from "@loopbound-ares/state";
import { useEffect as useEffect3, useState as useState6 } from "react";
import styled13, { keyframes as keyframes4 } from "styled-components";
import { jsx as jsx15, jsxs as jsxs13 } from "react/jsx-runtime";
var fadeIn4 = keyframes4`from{opacity:0;transform:translateY(20px);}to{opacity:1;transform:translateY(0);}`;
var Wrapper12 = styled13("div").withConfig({
  componentId: "sc-12rs98c-0"
})`height:100%;display:flex;position:relative;`;
var SidebarWrapper = styled13("div").withConfig({
  componentId: "sc-12rs98c-1"
})`height:calc(100vh - 60px);height:calc(100dvh - 60px);`;
var Sidebar = styled13("div").withConfig({
  componentId: "sc-12rs98c-2"
})`height:100%;overflow:auto;padding:0px;position:relative;width:260px;flex-shrink:0;display:flex;flex-direction:column;scrollbar-width:thin;scrollbar-color:${theme10.colors.gray400} ${theme10.colors.gray200};opacity:0;animation:${fadeIn4} 0.2s 0.05s cubic-bezier(0.26,1.11,0.87,1.25) forwards;&::-webkit-scrollbar{width:4px;}&::-webkit-scrollbar-thumb{background-color:${theme10.colors.gray400};}&::-webkit-scrollbar-track{background-color:${theme10.colors.gray200};}`;
var Outer3 = styled13("div").withConfig({
  componentId: "sc-12rs98c-3"
})`max-height:100%;flex-grow:1;padding:0px 10px 0px 0px;animation:${fadeIn4} 0.2s cubic-bezier(0.26,1.11,0.87,1.25);width:calc(100vw - 335px);`;
var SidebarInnerTop = styled13("div").withConfig({
  componentId: "sc-12rs98c-4"
})`padding:10px 10px 0px 10px;`;
var SidebarInnerBottom = styled13("div").withConfig({
  componentId: "sc-12rs98c-5"
})`padding:0px 10px 0px 10px;`;
var Content6 = styled13("div").withConfig({
  componentId: "sc-12rs98c-6"
})`height:calc(100dvh - 70px);background:${theme10.colors.background};border-radius:10px;box-shadow:${theme10.shadows.large};overflow:auto;`;
var Shadow = styled13("div").withConfig({
  componentId: "sc-12rs98c-7"
})`height:10px;background:linear-gradient(0deg,rgba(240,240,240,0) 0%,rgba(240,240,240,1) 100%);`;
var billingCardAnimation = keyframes4`0%{background-position:0% 50%;}50%{background-position:100% 50%;}100%{background-position:0% 50%;}`;
var BottomCard = styled13("button").withConfig({
  componentId: "sc-12rs98c-8"
})`box-shadow:${theme10.shadows.small};border-radius:11px;padding:1px;background:linear-gradient(to right,${theme10.colors.gray500},${theme10.colors.gray400});background-size:200% 200%;animation:${billingCardAnimation} 60s linear infinite;transition:transform 0.2s;border:none;outline:none;width:100%;&:hover,&:focus,&:focus-within{transform:scale(1.02);box-shadow:${theme10.shadows.large};}`;
var BottomCardInner = styled13("div").withConfig({
  componentId: "sc-12rs98c-9"
})`background:${theme10.colors.background};border-radius:9px;padding:10px 10px 10px 15px;display:flex;flex-direction:column;gap:10px;`;
var WorkspacePane = ({
  mainGroups,
  bottomGroups,
  children,
  onboarding
}) => {
  let instance = useCurrentInstance7();
  let billingObjectReference = {
    id: instance.data?.productWorkspace.id,
    type: "workspace_product"
  };
  let billingObject = useBillingObject(instance.data ? {
    organizationId: instance.data.organization.id,
    object: billingObjectReference
  } : null);
  let showPlanTable = () => {
    if (!instance.data || !billingObject.data)
      return null;
    showModal3(({
      dialogProps
    }) => {
      return /* @__PURE__ */ jsx15(LargePanelDialog.Wrapper, { ...dialogProps, children: /* @__PURE__ */ jsx15("div", { style: {
        maxWidth: "100%",
        width: 900,
        padding: "max(8vh, 30px) 20px",
        display: "flex",
        flexDirection: "column",
        margin: "0 auto"
      }, children: /* @__PURE__ */ jsx15(RenderPricingTable, { organizationId: instance.data.organization.id, object: billingObjectReference }) }) });
    });
  };
  let onboardingData = useOnboardingList(onboarding ? {
    ...onboarding,
    hideIfCompleted: true
  } : void 0);
  let [showOnboarding, setShowOnboarding] = useState6(false);
  useEffect3(() => {
    if (onboardingData.data?.isSkipped)
      setShowOnboarding(false);
    else if (onboardingData.shouldRender)
      setShowOnboarding(true);
  }, [onboardingData.shouldRender, onboardingData.data]);
  return /* @__PURE__ */ jsx15(RootLayout, { children: /* @__PURE__ */ jsxs13(Wrapper12, { children: [
    /* @__PURE__ */ jsx15(SidebarWrapper, { children: /* @__PURE__ */ jsxs13(Sidebar, { children: [
      /* @__PURE__ */ jsx15(SidebarInnerTop, { children: /* @__PURE__ */ jsx15(SidebarItems, { groups: mainGroups }) }),
      /* @__PURE__ */ jsx15(Spacer3, {}),
      /* @__PURE__ */ jsxs13("div", { style: {
        position: "sticky",
        bottom: 0,
        zIndex: 10
      }, children: [
        /* @__PURE__ */ jsx15(Shadow, { style: {
          height: 20,
          transform: "rotate(180deg)"
        } }),
        /* @__PURE__ */ jsxs13("div", { style: {
          background: "var(--lb-bg)"
        }, children: [
          bottomGroups && /* @__PURE__ */ jsx15(SidebarInnerBottom, { children: /* @__PURE__ */ jsx15(SidebarItems, { groups: bottomGroups }) }),
          /* @__PURE__ */ jsxs13("div", { style: {
            padding: "10px 10px 10px 10px",
            display: "flex",
            flexDirection: "column",
            gap: 10
          }, children: [
            showOnboarding && onboarding && /* @__PURE__ */ jsx15(BottomCard, { as: "div", children: /* @__PURE__ */ jsx15(BottomCardInner, { children: /* @__PURE__ */ jsx15(OnboardingList, { skipOnboarding: "enabled_floating_button", ...onboarding }) }) }),
            billingObject.data?.object.plan.provider == "free" && instance.data && /* @__PURE__ */ jsx15(BottomCard, { onClick: showPlanTable, children: /* @__PURE__ */ jsxs13(BottomCardInner, { children: [
              /* @__PURE__ */ jsxs13(Text7, { size: "2", weight: "medium", children: [
                "Upgrade to unlock",
                /* @__PURE__ */ jsx15("br", {}),
                "more features."
              ] }),
              /* @__PURE__ */ jsx15(Button7, { fullWidth: true, size: "2", as: "div", children: "Upgrade" })
            ] }) }),
            billingObject.data?.object.willDowngrade && instance.data && /* @__PURE__ */ jsx15(BottomCard, { onClick: showPlanTable, children: /* @__PURE__ */ jsxs13(BottomCardInner, { children: [
              /* @__PURE__ */ jsx15(Text7, { size: "2", weight: "medium", children: "Your plan will downgrade to free soon. Reactivate now to keep your features." }),
              /* @__PURE__ */ jsx15(Button7, { fullWidth: true, size: "2", as: "div", children: "Upgrade" })
            ] }) })
          ] }),
          /* @__PURE__ */ jsx15(Spacer3, { height: 0 })
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ jsx15(Outer3, { children: /* @__PURE__ */ jsx15(Content6, { children }) })
  ] }) });
};

// src/pages/index.ts
var pages_exports = {};
__export(pages_exports, {
  HomePage: () => HomePage
});
__reExport(pages_exports, components_star);
import * as components_star from "@loopbound-ares/components";

// src/pages/home.tsx
import { Avatar as Avatar2, Button as Button8, LinkButton as LinkButton4, Menu as Menu4, Spacer as Spacer4, Text as Text8, Title as Title4, theme as theme11 } from "@lb-lib/ui";
import { ContentLayout as ContentLayout2, PageHeader as PageHeader3, renderWithLoader as renderWithLoader2 } from "@loopbound-ares/components";
import { bootWorkspace as bootWorkspace3, getServiceUrl as getServiceUrl3, useOrganizations as useOrganizations3, useShell as useShell6, useUser as useUser2 } from "@loopbound-ares/state";
import { RiAddLine as RiAddLine3, RiMore2Line } from "@remixicon/react";
import { useEffect as useEffect4, useMemo as useMemo3, useState as useState7 } from "react";
import { Link as Link5, useNavigate as useNavigate3 } from "react-router-dom";
import { toast } from "sonner";
import styled14 from "styled-components";
import { Fragment as Fragment8, jsx as jsx16, jsxs as jsxs14 } from "react/jsx-runtime";
var ProjectGrid = styled14("div").withConfig({
  componentId: "sc-1n6s6cg-0"
})`display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:10px;`;
var ProjectCard = styled14("div").withConfig({
  componentId: "sc-1n6s6cg-1"
})`border:1px solid ${theme11.colors.gray300};border-radius:10px;padding:20px;display:flex;flex-direction:column;flex-grow:1;`;
var WorkspaceSection = styled14("section").withConfig({
  componentId: "sc-1n6s6cg-2"
})`padding:10px;border:1px solid ${theme11.colors.gray300};border-radius:10px;margin-bottom:20px;`;
var WorkspaceHeader2 = styled14("header").withConfig({
  componentId: "sc-1n6s6cg-3"
})`display:flex;align-items:center;gap:10px;`;
var WorkspaceInner = styled14("main").withConfig({
  componentId: "sc-1n6s6cg-4"
})`margin-top:10px;`;
var InviteBar = styled14("div").withConfig({
  componentId: "sc-1n6s6cg-5"
})`display:flex;justify-content:space-between;align-items:center;border:1px solid ${theme11.colors.gray300};padding:15px 15px 15px 20px;border-radius:10px;margin-bottom:10px;`;
var HomePage = () => {
  let organizations = useOrganizations3();
  let user = useUser2();
  let shell = useShell6();
  let navigate = useNavigate3();
  let [showCreateOrganizationSaved, setShowCreateOrganizationSaved] = useState7(false);
  let showCreateOrganization = useMemo3(() => showCreateOrganizationSaved || !organizations.isLoading && !organizations.error && organizations.data?.length == 0, [organizations.isLoading, organizations.error, organizations.data, showCreateOrganizationSaved]);
  useEffect4(() => {
    if (showCreateOrganization)
      setShowCreateOrganizationSaved(true);
  }, [showCreateOrganization]);
  if (showCreateOrganization) {
    return /* @__PURE__ */ jsx16(BoxLayout, { children: /* @__PURE__ */ jsx16(CreateOrganization, {}) });
  }
  return /* @__PURE__ */ jsxs14(Fragment8, { children: [
    /* @__PURE__ */ jsx16(Spacer4, { height: "max(20px, 5vw)" }),
    /* @__PURE__ */ jsx16(ContentLayout2, { variant: "medium", children: renderWithLoader2({
      user,
      organizations
    })(() => {
      return /* @__PURE__ */ jsxs14(Fragment8, { children: [
        /* @__PURE__ */ jsx16("div", { style: {
          background: `linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.8) 80%, rgba(255, 255, 255, 0) 100%)`,
          position: "sticky",
          top: 0,
          zIndex: 50,
          padding: "20px 30px 5px 30px",
          marginLeft: -30,
          marginRight: -30
        }, children: /* @__PURE__ */ jsx16(PageHeader3, { title: `Welcome back, ${user.data?.firstName ?? user.data?.name}!`, description: "Choose a project to continue.", actions: /* @__PURE__ */ jsx16(Button8, { variant: "solid", size: "1", iconLeft: /* @__PURE__ */ jsx16(RiAddLine3, {}), onClick: () => createOrganization(), children: "Create Organization" }) }) }),
        organizations.data?.flatMap((organization) => organization.workspaces.sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime()).map((workspace) => {
          let workspaceProduct = workspace.productWorkspaces.find((p) => p.product == shell.product.id);
          let projects = workspaceProduct ? organization.projects.filter((p) => p.workspaceProductId == workspaceProduct.id) : [];
          let doCreateProject = async () => {
            try {
              let wsp = workspaceProduct ?? (await bootWorkspace3({
                workspaceId: workspace.id
              })).productWorkspace;
              createProject({
                workspaceProduct: wsp
              });
            } catch (e) {
              toast.error(e.data.message ?? e.message);
            }
          };
          return /* @__PURE__ */ jsxs14(WorkspaceSection, { children: [
            /* @__PURE__ */ jsxs14(WorkspaceHeader2, { children: [
              /* @__PURE__ */ jsx16("div", { children: /* @__PURE__ */ jsx16(Avatar2, { entity: workspace }) }),
              /* @__PURE__ */ jsxs14("div", { children: [
                /* @__PURE__ */ jsx16(Title4, { as: "h2", size: "3", weight: "strong", children: workspace.name }),
                /* @__PURE__ */ jsxs14(Text8, { size: "1", weight: "medium", color: "gray600", children: [
                  workspace.slug,
                  organization.workspaces.length > 1 && ` \u2022 ${organization.organization.name}`
                ] })
              ] }),
              /* @__PURE__ */ jsx16(Spacer4, {}),
              /* @__PURE__ */ jsxs14("div", { style: {
                display: "flex",
                gap: 10,
                alignItems: "center"
              }, children: [
                /* @__PURE__ */ jsx16(Button8, { variant: "outline", size: "1", iconLeft: /* @__PURE__ */ jsx16(RiAddLine3, {}), onClick: doCreateProject, children: "Create Project" }),
                /* @__PURE__ */ jsx16(Menu4, { items: [{
                  id: "create-project",
                  label: "Create Project"
                }, {
                  id: "settings",
                  label: "Settings"
                }], onItemClick: (id) => {
                  if (id == "create-project" && workspaceProduct) {
                    doCreateProject();
                  } else if (id == "settings") {
                    navigate(getServiceUrl3("admin", routes.organization_settings_home({
                      organizationSlug: organization.organization.slug
                    })));
                  }
                }, children: /* @__PURE__ */ jsx16(Button8, { variant: "outline", size: "1", iconLeft: /* @__PURE__ */ jsx16(RiMore2Line, {}), title: "More options" }) })
              ] })
            ] }),
            /* @__PURE__ */ jsxs14(WorkspaceInner, { children: [
              projects.length > 0 && organization.member.role == "admin" && /* @__PURE__ */ jsxs14(InviteBar, { children: [
                /* @__PURE__ */ jsx16(Text8, { size: "2", weight: "medium", children: "Invite people to your organization" }),
                /* @__PURE__ */ jsx16(Link5, { to: getServiceUrl3("admin", routes.organization_settings_invites({
                  organizationSlug: organization.organization.slug
                })), children: /* @__PURE__ */ jsx16(Button8, { size: "2", children: "Invite Team" }) })
              ] }),
              /* @__PURE__ */ jsx16(ProjectGrid, { children: projects.map((project) => {
                let instance = project.instances.find((i) => i.environment.type == "development") ?? project.instances[0];
                if (project.status == "deleted")
                  return null;
                return /* @__PURE__ */ jsx16(Link5, { to: routes.instance_home({
                  instanceSlug: instance.slug
                }), style: {
                  display: "flex"
                }, children: /* @__PURE__ */ jsxs14(ProjectCard, { children: [
                  /* @__PURE__ */ jsx16(Title4, { as: "h3", size: "3", weight: "bold", children: project.name }),
                  /* @__PURE__ */ jsx16(Text8, { size: "2", color: "gray600", children: project.slug }),
                  /* @__PURE__ */ jsx16(Spacer4, { size: 15, grow: true }),
                  /* @__PURE__ */ jsx16("div", { children: /* @__PURE__ */ jsx16(Button8, { as: "div", size: "2", children: "Open" }) })
                ] }) }, instance.id);
              }) }),
              projects.length === 0 && /* @__PURE__ */ jsxs14(Text8, { size: "2", color: "gray700", weight: "medium", children: [
                "Your organization doesn't have any projects yet.",
                " ",
                /* @__PURE__ */ jsx16(LinkButton4, { onClick: doCreateProject, children: "Create one" }),
                "."
              ] })
            ] })
          ] }, workspace.id);
        }))
      ] });
    }) })
  ] });
};

// src/index.ts
__reExport(src_exports, pages_exports);

// src/support/index.ts
import { dynamicComponent as dynamicComponent9 } from "@lb-lib/dynamic-component";
var TicketChat = dynamicComponent9(async () => (await import("./ticketChat-W5CVPYBD.js")).TicketChat);
var TicketList = dynamicComponent9(async () => (await import("./ticketList-7W4KQPAM.js")).TicketList);
export {
  AccountEmailsScene,
  AccountOrganizationsScene,
  AccountProfileScene,
  AccountSecurityScene,
  ApiErrors,
  ApiKeyListTable,
  AppLayout,
  ApplicationList,
  ApplicationsPage,
  BoxLayout,
  CreateOrganization2 as CreateOrganization,
  EventLogs,
  HomePage,
  InstanceHeaderLayout,
  LargePaneLayout,
  Nav,
  ObjectComments,
  ObjectGroupPage,
  ObjectHeader,
  OnboardingList2 as OnboardingList,
  OrgMemberReference,
  OrganizationAlertsScene,
  OrganizationAuditLogScene,
  OrganizationBillingScene,
  OrganizationGeneralScene,
  OrganizationInvitesScene,
  OrganizationMembersScene,
  OrganizationSSOScene,
  OrganizationWorkspaceScene,
  OrganizationWorkspacesScene,
  Plan,
  PriceHeader,
  RenderPricingTable,
  RequestLogs,
  RequestTimeline,
  Subscription,
  SwitcherHorizontal,
  SwitcherVertical,
  TicketChat,
  TicketList,
  User,
  WorkspaceEmptyState,
  WorkspacePane,
  createApiKeyModal,
  createApplicationModal2 as createApplicationModal,
  createInstance,
  createOrganization2 as createOrganization,
  createProject2 as createProject,
  getRoute as getAresRoute,
  openCheckoutModal,
  rollApiKeyModal,
  setRoute as setAresRoute,
  updateApiKeyModal,
  updateApplicationModal2 as updateApplicationModal,
  updateInstance,
  updateProject
};
//# sourceMappingURL=index.js.map